import React from "react";
import { FieldRenderProps } from "react-final-form";

const RadioInput: React.FC<FieldRenderProps<any, HTMLElement>> = ({
  input,
  id,
  label,
  disabled,
  labelClass,
  meta: { touched, error },
}) => {
  return (
    <div className="custom-control custom-radio">
      <input
        {...input}
        disabled={disabled}
        className="custom-control-input"
        id={id}
      />
      <label className={`${labelClass} custom-control-label`} htmlFor={id}>
        {label}
      </label>
    </div>
  );
};

export default RadioInput;
